export default __webpack_public_path__ + "8512797557a68c8f58c58b25a5f89e1e.svg";